module.exports = __webpack_public_path__ + "static/media/detail16.704a441c.jpg";